import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import { isKeyPressed } from "../../../../utils/isKeyPressed";
import { RETURN_KEY_CODE, SPACEBAR_KEY_CODE } from "../../../../utils/Browser/keyCodes";
import { jsx as _jsx } from "react/jsx-runtime";
const StyleButton = _ref => {
  let {
    style,
    active,
    label,
    onToggle
  } = _ref;
  const handleToggle = e => {
    e.preventDefault();
    onToggle(style);
  };
  const handleKeyDown = e => {
    if (isKeyPressed(e, "Enter", RETURN_KEY_CODE) || isKeyPressed(e, " ", SPACEBAR_KEY_CODE)) {
      handleToggle(e);
    }
  };
  const btnClasses = () => cn({
    'mt-1 text-medium-grey font-heavy-font cursor-pointer mr-2 py-1 px-2 inline-block': true,
    'text-text-blue': active,
    'hover:text-action-blue': !active,
    'font-bold': style === 'BOLD',
    'italic': style === 'ITALIC',
    'underline': style === 'UNDERLINE'
  });
  return /*#__PURE__*/_jsx("span", {
    className: btnClasses(),
    onMouseDown: handleToggle,
    onKeyDown: handleKeyDown,
    role: "button",
    tabIndex: 0,
    children: label
  });
};
StyleButton.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
  onToggle: PropTypes.func.isRequired,
  style: PropTypes.string.isRequired
};
export default StyleButton;
//# sourceMappingURL=StyleButton.js.map